import 'parsleyjs';
import MicroModal from 'micromodal';
import 'electro-privacy';
import LazyLoad from 'vanilla-lazyload';
import pym from 'pym.js';

// global js components
import KingsfordHeader from './components/kingsford-header';
import KingsfordFooter from './components/kingsford-footer';
import RegisterLogin from './components/register-login';
import Social from './components/social-widget';
import FAQPanel from './components/faq-panel';
import Scroll from './controllers/scroll';
import HeaderMenuItems from './controllers/headerMenuItems';
import ImageOverVideo from './components/image-over-video';

// pages
import HomePage from './pages/page-home';

// "Google Optimize" Content Controllers.
import Optimize from './controllers/optimize';
import { passSource } from './controllers/parametersWatcher';

import GatedContent from './controllers/gatedContent';

// Sentry
import * as Sentry from "@sentry/browser";


Sentry.init({
  dsn: Electro.Sentry.dsn,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: Electro.Sentry.environment,
  release: Electro.themeVersion,
  sampleRate: Electro.Sentry.sampleRate,
  maxBreadcrumbs: Electro.Sentry.maxBreadcrumbs,
  attachStacktrace: Electro.Sentry.attachStacktrace,
  tracesSampleRate: Electro.Sentry.tracesSampleRate,
  tracePropagationTargets: [WEBROOT],
  replaysSessionSampleRate: Electro.Sentry.replaysSessionSampleRate,
  replaysOnErrorSampleRate: Electro.Sentry.replaysOnErrorSampleRate,
});


// Constants
export const buttonFilledSvg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 400 190" preserveAspectRatio="none">
  <g>
    <path d="M399.9,69.8c-1.4-2.7-2.7-5.4-4.1-8.1.3-.3.6-.7,1-1.1-1.8-12.9-17.4-28-28.8-32.9.5,1.3.8,1.8,1,2.4-.2.2-.5.3-.7.5-1.5-1.3-3-2.6-4.3-3.7-3.2-.5-5-1.1-8.3-.6-.2-.6-.4-1.2-.6-1.7-.8.5-1.4.9-1.9,1.2-2.2-1.7-4.3-3.3-6.2-4.8-.5.5-.9.8-1.3,1.1-.5-.4-.8-.7-1.8-1.4-.6,1.1-1.1,2.1-1.5,2.8-2.1-.7-3.6-1.2-5.2-1.7-.2-.6-.4-1.3-.5-1.7-.9.4-1.7.8-2.5,1.1-.5-1.1-.8-1.8-1.2-2.7-4,3.5-19.8-3.3-24.5-4-5.7-4.6-13.7-1.6-19.4-5.5-5-1-8.8-1.7-12.6-2.5-.2.6-.3,1.2-.5,1.9-4-1.7-7.8-3.3-11.4-4.9-.6.5-1,.9-1.4,1.3-.4-.3-.8-.7-1.2-1.1-.4.8-.7,1.5-1.3,2.7-.2-1.1-.3-1.6-.5-2.3-5.6-3.6-12.2,0-18.5-2.6.5,1.2.8,2.1,1.1,3-.3.4-.6.8-.8,1.2,1,.3,1.7.6,2.3.8-.5.5-.8.9-1,1.2,0,0,0,.2.1.3-1.8-.2-3.7-.4-5.5-.5,1.1-.2,2.1-.4,3.4-.6-.6-1.1-1-1.8-1.3-2.4.3-1,.6-1.9.9-2.9h-6.6c-.3.8-.5,1.5-.8,2.2-1.8-.6-3.5-1.1-5.2-1.6-.2-.6-.4-1.2-.7-2.3-1,1.5-1.7,2.6-2.5,3.7-.1-.1-.2-.2-.3-.3-.8.3-1.7.6-2.4.9.5.7.8,1.1,1.2,1.6-.6.2-1.2.4-1.8.6-.8,0-1.6,0-2.4-.1,1.5-2.1,2.8-3.9,4.5-6.3-1.7.6-2.6,1-3.1,1.2-1.1-.3-2-.5-2.9-.7.4,1.3.7,2.2,1.3,4-2-1.8-4.2-1.9-4.4-4.1h-2.4c-.2.6-.4,1.3-.6,1.7-2,1.1-3.9,2.2-6.4,3.6.5,0,1,.1,1.5.3-1.5,0-3.1,0-4.7,0-14.4,0-28.5.7-42,2.1v-3.7h0c-.9-.9-1.9-1.9-2.9-2.9-20.7,0-41.4,12.3-61.8,12.6-3,2.9-7.7,1.7-10.7,4.6-20.3,4.3-40.3,19.3-55.7,32.4h-4.2c.5.9.9,1.7.9,1.7-1.3,1.3-2.3,2.3-3.1,3.1,0-.2-.3-.9-.6-1.6-.6.1-1.1.2-1.8.3v2.9c-1.3,1.8-2.1,2.9-2.4,3.3-1.9.6-3,.9-3.9,1.2-1-.3-1.7-.6-3.1-1,.7,1.4,1,2.1,1.5,3.1-.7.3-1.3.6-2.2.9-.5,1.1-1.2,2.6-1.6,3.6-1.3.9-2.3,1.6-3.3,2.3.5.6.8,1,.9,1.1-1.4,2.4-4.7,5.7-5.5,7.8.4.7.8,1.5,1.3,2.2-.5.9-.9,1.6-1.3,2.4.4.7.7,1.2,1,1.6-.4.8-.8,1.4-1.1,2.1.9,1,1.7,1.8,2.8,3-1.3,1.1-2.6,2.2-3.8,3.1,0,1,0,1.7.1,2.5,1.2.2,2.2.3,3.5.5-.6.6-.9,1-1.2,1.4,1.8,2.4,3.6,4.8,5.5,7.2-.8.3-1.5.5-2,.7v2.8c.8.3,1.5.5,2.3.8v4.1c1.2-.1,2.2-.3,2.9-.4-.3-1.3-.5-2.2-.8-3.6,3.4,2.9,5.2,6.1,6.2,9.4.7.2,1.2.4,1.8.7-.5.7-.8,1-1.2,1.6,1.3.2,2.4.4,2.9.5.7,1.1,1.1,1.7,1.5,2.4.3,0,.6-.2.9-.3l-.8-3.2c.2-.1.5-.2.7-.3,2,2.2,4,4.5,5.8,6.5.8-.3,1.6-.5,2.4-.8.3,1.5.4,2.5.5,2.9,8.2,3.8,15.7,12.3,24.4,14.5,8,6.9,21.1,12,31.3,14.1.4.4,1.1,1.1,1.3,1.3,11.1,3.6,22.3,6.6,33.6,9.2,8.7,2,25.9,2,32.6,7.6-1.3.8-2.1,1.2-3.1,1.8,1.3.3,2.4.6,3.8.9-1.3.9-3.4.5-2.1,2.9h4.2c2.7,1.9,5.5,4.7,8.9,4.7.3-1.4.4-2.5.6-3.4h2.5c.6,1.1,1.3,2.2,1.8,3.1,4.6,1.4,10.9,3.1,15.4,1.4.4.8.7,1.6,1,2.1h3.9c-1.4-1.3-2.2-2.1-3.2-2.9,1.5-.1,2.9-.5,4.2-1.2.3,1,.5,2,1,4,.4-2.2.6-3.2.9-5,1,1.4,1.6,2.3,2,2.8,1.4-.4,2.4-.8,3.3-1,1.3,1,2.5,1.9,3.8,2.8.5-1.1.9-1.9,1.4-3,.8.5,1.6.9,2.8,1.6.9-1.1,2-2.5,3-3.7,2.1,1,4,1.9,5.4,2.6,1,1.3,1.6,2.3,2.4,3.3,1.8-1.9,3.3-3.8,5.7-1.3.8-.8,1.6-1.5,2.4-2.3h10.2c1.7-1.1,3.3-2.2,4.9-3.3.3.8.5,1.5.8,2.4.5-1,.8-1.8,1.2-2.5h1.3c.4.7.7,1.5,1.1,2.3.4-.7.7-1.4.9-2.1,5.6-.3,9.8-1.2,12.5-2.7,2.1,1,5-1.1,7.1,1.1,1.8-.7,3.6-1.4,5.5-2.1,1.7,1.4,3.6,1.6,5.8.6v-3c1.1,1,2,1.7,2.8,2.3.6-.5.8-.8,1.1-1,.4.8.7,1.5,1.1,2.2.5-.4.9-.7,1.2-1,.5.4.9.7.8.7,2.6-2.6,5-4.9,7.5-7.3-.3-.3-.6-.6-1.1-1.1,1.5,0,2.9-.5,4.3-1.1.8.4,1.4.7,2,1,.9-1.4,1.6-2.5,2.4-3.7.6.5,1,.8,1.4,1.2,1.5-1.5,3-3,3.8-3.8,6.6-2.6,12.7-4.1,18.5-7.6,4.5-.1,8.8-2.8,13.5-4.4.2.7.5,1.3.7,2,2.7-2.4,11.5-2,15.1-2.7,1.2-.8,2.6-1.7,4.2-2.8v-2.5h2.4c8.6-7.5,16.3-17.2,22.3-26.9,6.7-10.8,9.3-22.6,15.3-33.3-1.1-.7-1.9-1.3-3.1-2.2,2.2-1.8,3.9-3.3,5.1-4.2.7-4.3-.7-7.9,1.1-11.1ZM292.7,16.5s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0ZM268.2,11.4c-.6,0-1.2-.2-1.7-.3-.1-.4-.3-.8-.4-1.2,1.1.3,1.8.8,2.2,1.5ZM259.9,8.4c.6.7,1,1.3,1.4,1.8-.8-.1-1.6-.2-2.3-.3.3-.5.6-1,1-1.5Z"/>
    <path d="M224.9,3.4s0,0,0,0c-.2-.2-.1-.1,0,0Z"/>
  </g>
</svg>`;
export const buttonOutlineSvg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 400 191" preserveAspectRatio="none">
  <g>
    <path d="M160.6,4.5c-.9-.9-1.9-1.9-2.9-2.9-20.7,0-41.4,12.3-61.8,12.6-3,2.9-7.7,1.7-10.7,4.6-20.3,4.3-40.3,19.3-55.7,32.4h-4.2c.5.9.9,1.7.9,1.7-1.3,1.3-2.3,2.3-3.1,3.1,0-.2-.3-.9-.6-1.6-.6.1-1.1.2-1.8.3v2.9c-1.3,1.8-2.1,2.9-2.4,3.3-1.9.6-3,.9-3.9,1.2-1-.3-1.7-.6-3.1-1,.7,1.4,1,2.1,1.5,3.1-.7.3-1.3.6-2.2.9-.5,1.1-1.2,2.6-1.6,3.6-1.3.9-2.3,1.6-3.3,2.3.5.6.8,1,.9,1.1-1.4,2.4-4.7,5.7-5.5,7.8.4.7.8,1.5,1.3,2.2-.5.9-.9,1.6-1.3,2.4.4.7.7,1.2,1,1.6-.4.8-.8,1.4-1.1,2.1.9,1,1.7,1.8,2.8,3-1.3,1.1-2.6,2.2-3.8,3.1,0,1,0,1.7.1,2.5,1.2.2,2.2.3,3.5.5-.6.6-.9,1-1.2,1.4,1.8,2.4,3.6,4.8,5.5,7.2-.8.3-1.5.5-2,.7v2.8c.8.3,1.5.5,2.3.8v4.1c1.2-.1,2.2-.3,2.9-.4-.3-1.3-.5-2.2-.8-3.6,3.4,2.9,5.2,6.1,6.2,9.4.7.2,1.2.4,1.8.7-.5.7-.8,1-1.2,1.6,1.3.2,2.4.4,2.9.5.7,1.1,1.1,1.7,1.5,2.4.3,0,.6-.2.9-.3l-.8-3.2c.2-.1.5-.2.7-.3,2,2.2,4,4.5,5.8,6.5.8-.3,1.6-.5,2.4-.8.3,1.5.4,2.5.5,2.9,8.2,3.8,15.7,12.3,24.4,14.5,8,6.9,21.1,12,31.3,14.1.4.4,1.1,1.1,1.3,1.3,11.1,3.6,22.3,6.6,33.6,9.2,8.7,2,25.9,2,32.6,7.6-1.3.8-2.1,1.2-3.1,1.8,1.3.3,2.4.6,3.8.9-1.3.9-3.4.5-2.1,2.9h4.2c2.7,1.9,5.5,4.7,8.9,4.7.3-1.4.4-2.5.6-3.4h2.5c.6,1.1,1.3,2.2,1.8,3.1,4.6,1.4,10.9,3.1,15.4,1.4.4.8.7,1.6,1,2.1h3.9c-1.4-1.3-2.2-2.1-3.2-2.9,1.5-.1,2.9-.5,4.2-1.2.3,1,.5,2,1,4,.4-2.2.6-3.2.9-5,1,1.4,1.6,2.3,2,2.8,1.4-.4,2.4-.8,3.3-1,1.3,1,2.5,1.9,3.8,2.8.5-1.1.9-1.9,1.4-3,.8.5,1.6.9,2.8,1.6.9-1.1,2-2.5,3-3.7,2.1,1,4,1.9,5.4,2.6,1,1.3,1.6,2.3,2.4,3.3,1.8-1.9,3.3-3.8,5.7-1.3.8-.8,1.6-1.5,2.4-2.3h10.2c1.7-1.1,3.3-2.2,4.9-3.3.3.8.5,1.5.8,2.4.5-1,.8-1.8,1.2-2.5h1.3c.4.7.7,1.5,1.1,2.3.4-.7.7-1.4.9-2.1,5.6-.3,9.8-1.2,12.5-2.7,2.1,1,5-1.1,7.1,1.1,1.8-.7,3.6-1.4,5.5-2.1,1.7,1.4,3.6,1.6,5.8.6v-3c1.1,1,2,1.7,2.8,2.3.6-.5.8-.8,1.1-1,.4.8.7,1.5,1.1,2.2.5-.4.9-.7,1.2-1,.5.4.9.7.8.7,2.6-2.6,5-4.9,7.5-7.3-.3-.3-.6-.6-1.1-1.1,1.5,0,2.9-.5,4.3-1.1.8.4,1.4.7,2,1,.9-1.4,1.6-2.5,2.4-3.7.6.5,1,.8,1.4,1.2,1.5-1.6,3-3,3.8-3.8,6.6-2.6,12.7-4.1,18.5-7.6,4.5-.1,8.8-2.8,13.5-4.4.2.7.5,1.3.7,2,2.7-2.4,11.5-2,15.1-2.7,1.2-.8,2.6-1.7,4.2-2.8v-2.5h2.4c8.6-7.5,16.3-17.2,22.3-26.9,6.7-10.8,9.3-22.6,15.3-33.3-1.1-.7-1.9-1.3-3.1-2.2,2.2-1.8,3.9-3.3,5.1-4.2.7-4.3-.7-7.9,1.1-11.1-1.4-2.7-2.7-5.4-4.1-8.1.3-.3.6-.7,1-1.1-1.8-12.9-17.4-28-28.8-32.9.5,1.3.8,1.8,1,2.4-.2.2-.5.3-.7.5-1.5-1.3-3-2.6-4.3-3.7-3.2-.5-5-1.1-8.3-.6-.2-.6-.4-1.2-.6-1.7-.8.5-1.4.9-1.9,1.2-2.2-1.7-4.3-3.3-6.2-4.8-.5.5-.9.8-1.3,1.1-.5-.4-.8-.7-1.8-1.4-.6,1.1-1.1,2.1-1.5,2.8-2.1-.7-3.6-1.2-5.2-1.7-.2-.6-.4-1.3-.5-1.7-.9.4-1.7.8-2.5,1.1-.5-1.1-.8-1.8-1.2-2.7-4,3.5-19.8-3.3-24.5-4-5.7-4.6-13.7-1.6-19.4-5.5-5-1-8.8-1.7-12.6-2.5-.2.6-.3,1.2-.5,1.9-4-1.7-7.8-3.3-11.4-4.9-.6.5-1,.9-1.4,1.3-.4-.3-.8-.7-1.2-1.1-.4.8-.7,1.5-1.3,2.7-.2-1.1-.3-1.6-.5-2.3-5.6-3.6-12.2,0-18.5-2.6.5,1.2.8,2.1,1.1,3-.3.4-.6.8-.8,1.2,1,.3,1.7.6,2.3.8-.5.5-.8.9-1,1.2.5,1.1,1,2,1.4,2.6,4.6,1.2,8.3,1.5,13,1.5.8-1.2,1.5-2.3,2.2-3.5.8,1,1.3,1.7,1.7,2.3-.5.8-.9,1.4-1.3,2h6.7c-.4-1.1-.7-2-1-2.9,2,.6,2.8,1.8,2.5,3.7,7.7,1.8,14.9,3.4,22.4,5.1.5-.6,1.2-1.5,1.7-2.2,1.4,1.7,2.6,3.3,3.3,4.2,11.1,1.7,20.6,6,29.7,9.6,1.3-.5,2.2-.8,3.7-1.4-.7,1.2-1,1.7-1.5,2.5,32.8,15.4,75.6,47.1,43.1,84.9-12.7,14.8-30.7,23.6-48.4,30.9-15.5,6.4-37.8,15.1-54.8,14.1-4.2,6.6-32.3,3-38.8,5.8-.5-.4-.9-.8-1.3-1.2-2.4,3.4-21.1,1-24.5,1.1-9.5,0-19,.1-28.4-.7-16.7-1.6-35.6-7.9-52.2-7.3-9.7-6.3-26-7-37.1-11.6-12.9-5.3-25.5-11.4-36.7-19.8-18.3-13.6-30.3-34.3-20-56.1,10-21.2,35.2-34.6,56.3-42,11.9-4.2,23.3-8.7,35.7-11.4,8.2-1.7,22.2-6.8,30.7-4.9,2.7-2.1,6.6-.3,9.1-3v-5.5h0ZM215.1,7.5c3.4.7,15,.1,17.5,1.9,1-1.5,4.2.3,6-.2-.5-.7-.8-1.1-1.2-1.6,1.4-.2,2.4-.4,3.9-.7-.6-1.1-1-1.8-1.3-2.4.3-1,.6-1.9.9-2.9h-6.6c-.3.8-.5,1.5-.8,2.2-1.8-.6-3.5-1.1-5.1-1.6-.2-.6-.4-1.2-.7-2.3-1,1.5-1.7,2.6-2.5,3.7-.3-.3-.6-.6-.3-.3-.8.3-1.7.6-2.4.9.5.7.8,1.1,1.2,1.6-1.7.5-3.1,1-4.9,1.5,1.8-2.6,3.3-4.6,5.3-7.4-1.7.6-2.6,1-3.1,1.2-1.1-.3-2-.5-2.9-.7.4,1.3.7,2.2,1.3,4-2-1.8-4.2-1.9-4.4-4.1h-2.4c-.2.6-.4,1.3-.6,1.7-2,1.1-3.9,2.2-6.4,3.6,3.8.2,5.9,4.8,9.5,1.7h0Z"/>
  </g>
</svg>`;
class App {
    constructor() {
        // Load redirects before anything else.
        this.redirects();

        window.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    /**
     * Add redirects here that can not be handled by PHP
     */
    redirects() {
        if (window.location.search === '?utm_source=package&utm_medium=qrcode&utm_campaign=high-heat-briquets' && window.location.pathname === '/') {
            window.location.href = '/recipes/grilled-skirt-steak/?utm_source=package&utm_medium=qrcode&utm_campaign=high-heat-briquets';
        }
        if (window.location.search === '?utm_source=package&utm_medium=qrcode&utm_campaign=low-slow-briquets' && window.location.pathname === '/') {
            window.location.href = '/recipes/smoked-pork-butt/?utm_source=package&utm_medium=qrcode&utm_campaign=low-slow-briquets';
        }
    }

    loadModal() {
        /**
         * on load setup micromodal login/register popup
         *   show based on url params
         */
        if (!CLWP_PC_GLOBAL.isLoggedIn) {
            try {
                MicroModal.init({
                    awaitCloseAnimation: true,
                    closeTrigger: 'data-custom-close',
                    onShow: (modal) => {
                        const callbackHandler = modal.getAttribute('data-open-callback');
                        if (!callbackHandler) return;

                        const callbackHandlerArr = callbackHandler.split('.');
                        let callback = null;

                        if (callbackHandlerArr.length > 1) {
                            // Handle class.function format (e.g., "MyClass.myMethod")
                            const classHandler = callbackHandlerArr[0];
                            const methodName = callbackHandlerArr[1];
                            callback = window.Electro[classHandler]?.[methodName];
                        } else {
                            // Handle direct function format (e.g., "myFunction")
                            callback = window.Electro[callbackHandler];
                        }

                        if (callback && typeof callback === 'function') {
                            callback(modal);
                        }
                    },
                    onClose: (modal) => {
                        if (`#${modal.id} iframe`) {
                            const video = $(`#${modal.id} iframe`).attr('src');
                            $(`#${modal.id} iframe`).attr('src', '');
                            $(`#${modal.id} iframe`).attr('src', video);
                        }
                    },
                });

                const params = new URLSearchParams(window.location.search);
                // check if lytics_campaign is present, to pass the source.
                if (params.has('lytics_campaign')) {
                    passSource(params.get('lytics_campaign'), document.querySelectorAll('.pc-consumer-source input'));
                }

                if (params.has('loginModal')) {
                    MicroModal.show('modal-login', {
                        closeTrigger: 'data-custom-close',
                    });
                } else if (params.has('registerModal')) {
                    MicroModal.show('modal-signup', {
                        closeTrigger: 'data-custom-close',
                    });
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('micromodal error:', e);
            }

            $('#signup-form.multi-page').on('click', '.js-register-form-continue', (e) => {
                e.preventDefault();
                $('.modal-signup-page.page-1').hide();
                $('.modal-signup-page.page-2').fadeIn(200);
                $('.modal__back').fadeIn(200);
            });
            $('#modal-signup').on('click', '.modal__back', (e) => {
                e.preventDefault();
                $('.modal__back').hide();
                $('.modal-signup-page.page-2').hide();
                $('.modal-signup-page.page-1').fadeIn(200);
            });
            $('#signup-form.multi-page .page-1 input').on('change, keyup', (e) => {
                if ($('#signup-form').parsley().isValid({group: 'page-1'})) {
                    $('.js-register-form-continue').removeClass('e-button--disabled');
                } else {
                    $('.js-register-form-continue').add('e-button--disabled');
                }
            });

            // handle login/register when account page or cart
            let loginRedirect = null;
            $(document).on('click', '.js-user-account', (e) => {
                e.preventDefault();

                window.loginRedirect = e.currentTarget.getAttribute('href');
                if (
                    window.location.pathname !== '/my-account/login' &&
                    window.location.pathname !== '/my-account/register'
                ) {
                    if (Electro.DEBUG) {
                        console.info('Open Modal');
                    }

                    // allow user to login/register
                    MicroModal.show('modal-login', {
                        closeTrigger: 'data-custom-close',
                    });
                } else {
                    const activeForm = document.querySelector('.tab-form.active');
                    if (activeForm) {
                        activeForm.querySelector('input:first-of-type').focus();
                    }
                    if (document.querySelector('.js-header-drawer').classList.contains('is-active')) {
                        document.querySelector('.js-header-drawer').classList.remove('is-active');
                        document.querySelector('.js-header-overlay').classList.remove('is-active');
                    }
                }

                return false;
            });

            $(document).on('click', '#BVRRContainer .bv-submission-button', (e) => {
                e.preventDefault();
                e.stopPropagation();
                loginRedirect = `${window.location.origin + window.location.pathname}?reviewModal=1`;
                window.location = `/my-account/login?redirect_to=${loginRedirect}`;
            });
        } else if (window.KFD_Params.has('reviewModal')) {
            // show review modal if logged in and reviewModal query var present
            let refreshIntervalId = null;
            refreshIntervalId = setInterval(() => {
                if (typeof $BV !== 'undefined') {
                    clearInterval(refreshIntervalId);
                    setTimeout(() => {
                        $('#BVRRContainer .bv-submission-button').trigger('click');
                    }, 500);
                }
            }, 500);
        }
    }

    loginRedirect() {
        /**
         * Redirect users after successful login, to the redirect_to destination, or the current page
         */
        $(document).on('cloroxPreferenceCenterLogin cloroxPreferenceCenterRegister', (e) => {
            const loginRedirect = window.KFD_Params.has('redirect_to') ? window.KFD_Params.get('redirect_to') : null;
            const bveventId = window.KFD_Params.has('bveventid') ? window.KFD_Params.get('bveventid') : null;
            if (loginRedirect) {
                document.location = loginRedirect;
            } else if (window.loginRedirect) {
                document.location = window.loginRedirect;
            } else if (bveventId && document.referrer) {
                // Redirect to the referrer page if the user is coming from a review modal
                document.location = `${document.referrer}?bveventid=${bveventId}`;
            } else {
                document.location.reload();
            }
        });

    }

    gatedRecipes() {
        const {pathname} = window.location;
        const pathContains = (p) => window.location.pathname.indexOf(p) === 0;

        if (pathContains('/recipes/') && pathname !== '/recipes/') {
            const gatedContent = new GatedContent();
            gatedContent.init();
        }
    }

    setupShowPasswords() {
        const showPasswords = document.body.querySelectorAll('.show-password');

        if (showPasswords.length) {
            showPasswords.forEach((showPassword) => {
                showPassword.addEventListener('click', (e) => {
                    e.preventDefault();

                    const pwField = e.currentTarget.parentNode.querySelector('input');
                    e.currentTarget.classList.toggle('is-active');

                    if (pwField.type === 'password') {
                        pwField.type = 'text';
                    } else {
                        pwField.type = 'password';
                    }
                });
            });
        }
    }

    responsiveIframes() {
        const pathContains = (p) => window.location.pathname.indexOf(p) === 0;

        if (pathContains('/fireitup/' || '/cataboom/')) {
            const url = document.getElementById('hw-iframe').getAttribute('data-url');
            console.log(url, pym);
            const pymParent = new pym.Parent('hw-iframe', url, {});
        }
    }

    init() {
        window.KingsfordHeader = new KingsfordHeader();
        window.KingsfordFooter = new KingsfordFooter();
        window.KFD_Social = new Social();
        window.KFD_Params = new URLSearchParams(window.location.search);
        window.KFD_Scroll = new Scroll();
        new Optimize();
        this.loadModal();
        this.loginRedirect();
        this.responsiveIframes();
        new HeaderMenuItems();
        new LazyLoad();
        new HomePage();

        if ($('.module-video').length) {
            new ImageOverVideo();
        }

        if (document.querySelector('.b-faqs')) {
            const faqPanel = new FAQPanel();
            faqPanel.init();
        }

        const pathContains = (p) => window.location.pathname.indexOf(p) === 0;
        if (pathContains('/my-account/')) {
            window.RegisterLogin = new RegisterLogin();
        }
        this.gatedRecipes();

        document.querySelectorAll('.read-more-container').forEach((el) => {
            const content = el.querySelector('.read-more-content');
            const toggle = el.querySelector('.read-more-toggle');

            if (el.offsetHeight > 150) {
                content.classList.add('mobile-collapsed');
            } else {
                toggle.remove();
                return;
            }

            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                if (!toggle.classList.contains('open')) {
                    content.classList.remove('mobile-collapsed');
                    toggle.classList.add('open');
                } else {
                    content.classList.add('mobile-collapsed');
                    toggle.classList.remove('open');
                }
            });
        });

        this.setupShowPasswords();

        document.getElementById('do-not-share').addEventListener('click', (e) => {
            if(typeof OneTrust !== 'undefined') {
                OneTrust.ToggleInfoDisplay();
            }
        });

        // Share functions
        document.querySelectorAll('.facebook-share').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                window.KFD_Social.newWindow('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.URL) + '&quote=' + encodeURIComponent(document.URL));
                return false;
            });
        });
        document.querySelectorAll('.twitter-share').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                window.KFD_Social.newWindow('https://twitter.com/intent/tweet?text=' + encodeURIComponent(document.title) + ':%20'  + encodeURIComponent(document.URL));
                return false;
            });
        });
        document.querySelectorAll('.pinterest-share').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const thumbnail = el.getAttribute('data-thumbnail');
                window.KFD_Social.newWindow('http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(document.URL) + '&media=' + thumbnail + '&description=' +  encodeURIComponent(document.title) );
                return false;
            });
        });

        // registration form submit handler to google recaptcha v3 suport
        // recaptcha adds g-recaptcha-response to form data, but we must submit form on callback
        window.onPCRegisterSubmit = (token) => {
            $('form.register.ajax-form').submit();
        }
    }
}

function closeModal(id) {
    MicroModal.close(id);
}

window.closeModal = closeModal.bind();

export default App;
